import { transparentize as e } from "polished";
import { uiColors as n } from "@leafygreen-ui/palette";
import r, { createContext as t, useContext as o, useRef as i, useCallback as a, useEffect as l, useMemo as s, useState as c } from "react";
import d from "prop-types";
import { css as u, cx as p } from "@leafygreen-ui/emotion";
import { usePrevious as f, useIdAllocator as g, useViewportSize as b, useEventListener as h } from "@leafygreen-ui/hooks";
import { createDataProp as m, isComponentType as v, keyMap as y } from "@leafygreen-ui/lib";
import { fontFamilies as x, breakpoints as w, spacing as O } from "@leafygreen-ui/tokens";
import k, { Align as N, Justify as C } from "@leafygreen-ui/popover";
import { useUsingKeyboardContext as j } from "@leafygreen-ui/leafygreen-provider";
import S from "@leafygreen-ui/icon/dist/Checkmark";
import { jsx as D } from "@emotion/react";
import { isFragment as E } from "react-is";
import I, { Variant as P } from "@leafygreen-ui/button";
import _ from "@leafygreen-ui/icon/dist/CaretDown";
import z from "@leafygreen-ui/icon/dist/Warning";
function A(e, n) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, t);
  }
  return r;
}
function H(e) {
  for (var n = 1; n < arguments.length; n++) {
    var r = null != arguments[n] ? arguments[n] : {};
    n % 2 ? A(Object(r), !0).forEach(function (n) {
      T(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : A(Object(r)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function T(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}
function M() {
  return (M = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var t in r) Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
    }
    return e;
  }).apply(this, arguments);
}
function G(e, n) {
  if (null == e) return {};
  var r,
    t,
    o = function (e, n) {
      if (null == e) return {};
      var r,
        t,
        o = {},
        i = Object.keys(e);
      for (t = 0; t < i.length; t++) r = i[t], n.indexOf(r) >= 0 || (o[r] = e[r]);
      return o;
    }(e, n);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (t = 0; t < i.length; t++) r = i[t], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
function R(e, n) {
  return n || (n = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}
function L(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == r) return;
    var t,
      o,
      i = [],
      a = !0,
      l = !1;
    try {
      for (r = r.call(e); !(a = (t = r.next()).done) && (i.push(t.value), !n || i.length !== n); a = !0);
    } catch (e) {
      l = !0, o = e;
    } finally {
      try {
        a || null == r.return || r.return();
      } finally {
        if (l) throw o;
      }
    }
    return i;
  }(e, n) || B(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function V(e) {
  return function (e) {
    if (Array.isArray(e)) return F(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || B(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function B(e, n) {
  if (e) {
    if ("string" == typeof e) return F(e, n);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? F(e, n) : void 0;
  }
}
function F(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var r = 0, t = new Array(n); r < n; r++) t[r] = e[r];
  return t;
}
var K,
  Z,
  q,
  Y,
  U,
  W,
  X,
  $,
  J,
  Q,
  ee,
  ne,
  re,
  te,
  oe,
  ie,
  ae,
  le,
  se = "dark",
  ce = "light",
  de = (T(K = {}, ce, {
    label: {
      base: n.gray.dark3,
      disabled: n.gray.dark1
    },
    description: n.gray.dark1,
    border: {
      base: n.gray.light1,
      open: n.gray.dark1
    },
    text: {
      base: n.gray.dark3,
      deselected: n.gray.dark1,
      disabled: n.gray.base
    },
    menu: {
      shadow: e(.78, n.black)
    },
    option: {
      group: {
        label: n.gray.dark1,
        border: n.gray.light2
      },
      background: {
        base: n.white,
        hovered: n.gray.light2,
        focused: n.blue.light3
      },
      text: {
        base: n.gray.dark3,
        selected: n.blue.base,
        disabled: n.gray.base,
        focused: n.blue.dark2
      },
      icon: {
        base: n.gray.dark1,
        selected: n.blue.base,
        disabled: n.gray.base
      },
      indicator: {
        focused: n.blue.base
      }
    }
  }), T(K, se, {
    label: {
      base: n.white,
      disabled: n.gray.light1
    },
    description: n.gray.light1,
    border: {
      base: n.gray.dark2,
      open: n.gray.dark2
    },
    text: {
      base: n.white,
      deselected: n.gray.light1,
      disabled: n.gray.dark1
    },
    menu: {
      shadow: e(.2, n.black)
    },
    option: {
      group: {
        label: n.gray.light1,
        border: n.gray.dark1
      },
      background: {
        base: n.gray.dark2,
        hovered: n.gray.dark1,
        focused: n.blue.base
      },
      text: {
        base: n.white,
        selected: "#9DD0E7",
        disabled: n.gray.base,
        focused: n.white
      },
      icon: {
        base: n.gray.light1,
        selected: "#9DD0E7",
        disabled: n.gray.base
      },
      indicator: {
        focused: n.white
      }
    }
  }), K),
  ue = {
    XSmall: "xsmall",
    Small: "small",
    Default: "default",
    Large: "large"
  },
  pe = (T(Z = {}, ue.XSmall, {
    height: 22,
    text: 12,
    label: {
      text: 14,
      lineHeight: 16
    },
    description: {
      text: 14,
      lineHeight: 16
    },
    option: {
      text: 14
    },
    warningIcon: 12
  }), T(Z, ue.Small, {
    height: 28,
    text: 14,
    label: {
      text: 14,
      lineHeight: 16
    },
    description: {
      text: 14,
      lineHeight: 16
    },
    option: {
      text: 14
    },
    warningIcon: 14
  }), T(Z, ue.Default, {
    height: 36,
    text: 14,
    label: {
      text: 14,
      lineHeight: 16
    },
    description: {
      text: 14,
      lineHeight: 20
    },
    option: {
      text: 14
    },
    warningIcon: 14
  }), T(Z, ue.Large, {
    height: 48,
    text: 18,
    label: {
      text: 18,
      lineHeight: 21
    },
    description: {
      text: 18,
      lineHeight: 24
    },
    option: {
      text: 16
    },
    warningIcon: 17.5
  }), Z),
  fe = 36,
  ge = 16,
  be = {
    text: 16,
    lineHeight: 19
  },
  he = {
    text: 16,
    lineHeight: 22
  },
  me = {
    text: 16
  },
  ve = {
    None: "none",
    Error: "error"
  },
  ye = t({
    mode: ce,
    size: ue.Default,
    open: !1,
    disabled: !1
  }),
  xe = m("option"),
  we = u(q || (q = R(["\n  display: flex;\n  width: 100%;\n  padding: 10px 12px;\n  outline: none;\n  overflow-wrap: anywhere;\n  transition: background-color 150ms ease-in-out;\n  position: relative;\n\n  &:before {\n    content: '';\n    position: absolute;\n    transform: scaleY(0.3);\n    top: 7px;\n    bottom: 7px;\n    left: 0;\n    right: 0;\n    width: 4px;\n    border-radius: 0px 4px 4px 0px;\n    opacity: 0;\n    transition: all 150ms ease-in-out;\n  }\n"]))),
  Oe = u(Y || (Y = R(["\n  display: flex;\n  align-items: center;\n"]))),
  ke = u(U || (U = R(["\n  min-width: 16px;\n  margin-right: 6px;\n"]))),
  Ne = u(W || (W = R(["\n  ", ":focus & {\n    color: currentColor;\n  }\n"])), xe.selector);
function Ce(e) {
  var n,
    t,
    s = e.children,
    c = e.className,
    d = e.glyph,
    g = e.selected,
    b = e.focused,
    h = e.disabled,
    m = e.onClick,
    v = e.onFocus,
    y = e.isDeselection,
    x = e.triggerScrollIntoView,
    w = e.hasGlyphs,
    O = o(ye).mode,
    k = j().usingKeyboard,
    N = de[O].option,
    C = i(null),
    E = a(function () {
      if (null == C.current) return null;
      var e = C.current,
        n = null == e ? void 0 : e.offsetParent;
      if (!n) return null;
      n.scrollTop = e.offsetTop + (e.clientHeight - n.clientHeight) / 2;
    }, [C]),
    I = f(x),
    P = x && !I;
  l(function () {
    P && E();
  }, [E, P]);
  var _ = f(b),
    z = b && !_;
  l(function () {
    z && C.current.focus();
  }, [z]);
  var A,
    H = D("span", {
      className: p(Oe, T({}, u(X || (X = R(["\n          font-weight: bold;\n        "]))), g && !y))
    }, s),
    G = D("span", {
      className: p(ke, u($ || ($ = R(["\n          height: 100%;\n        "]))))
    }),
    L = G;
  d && (d.type.isGlyph ? L = r.cloneElement(d, {
    key: "glyph",
    className: p(ke, u(J || (J = R(["\n            color: ", ";\n          "])), N.icon.base), (A = {}, T(A, Ne, k), T(A, u(Q || (Q = R(["\n              color: ", ";\n            "])), N.icon.disabled), h), A), d.props.className)
  }) : console.error("`Option` instance did not render icon because it is not a known glyph element."));
  var V,
    B = g && !y ? D(S, {
      key: "checkmark",
      className: p(ke, u(ee || (ee = R(["\n            color: ", ";\n          "])), N.icon.selected), (n = {}, T(n, Ne, k), T(n, u(ne || (ne = R(["\n              color: ", ";\n            "])), N.icon.disabled), h), n))
    }) : G;
  return V = w ? D("span", {
    className: u(re || (re = R(["\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n        "])))
  }, D("span", {
    className: u(te || (te = R(["\n            display: flex;\n          "])))
  }, L, H), B) : D(r.Fragment, null, B, H), D("li", M({}, xe.prop, {
    role: "option",
    "aria-selected": g,
    tabIndex: -1,
    ref: C,
    className: p(we, u(oe || (oe = R(["\n          cursor: pointer;\n          color: ", ";\n        "])), N.text.base), (t = {}, T(t, u(ie || (ie = R(["\n            &:hover {\n              background-color: ", ";\n            }\n          "])), N.background.hovered), !h), T(t, u(ae || (ae = R(["\n            &:focus {\n              color: ", ";\n              background-color: ", ";\n\n              &:before {\n                opacity: 1;\n                transform: scaleY(1);\n                background-color: ", ";\n              }\n            }\n          "])), N.text.focused, N.background.focused, N.indicator.focused), k && !h), T(t, u(le || (le = R(["\n            cursor: not-allowed;\n            color: ", ";\n          "])), N.text.disabled), h), t), c),
    onClick: m,
    onFocus: v,
    onKeyDown: void 0
  }), V);
}
function je(e) {
  throw Error("`Option` must be a child of a `Select` instance");
}
Ce.displayName = "Option", je.displayName = "Option";
var Se,
  De,
  Ee,
  Ie,
  Pe = d.oneOfType([d.string, d.number]);
je.propTypes = {
  children: d.oneOfType([Pe, d.arrayOf(d.oneOfType([Pe, d.oneOf([!1, null, void 0, ""])]))]).isRequired,
  className: d.string,
  glyph: d.element,
  value: d.string,
  disabled: d.bool
};
var _e = u(Se || (Se = R(["\n  padding-top: 8px;\n"]))),
  ze = u(De || (De = R(["\n  cursor: default;\n  width: 100%;\n  padding: 0 12px 2px;\n  outline: none;\n  overflow-wrap: anywhere;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n"])));
function Ae(e) {
  var n = e.className,
    r = e.label,
    t = e.children,
    i = o(ye).mode,
    a = de[i].option,
    l = g({
      prefix: "select-option-group"
    });
  return D("div", {
    className: p(_e, u(Ee || (Ee = R(["\n          border-bottom: 1px solid ", ";\n        "])), a.group.border), n)
  }, D("div", {
    id: l,
    className: p(ze, u(Ie || (Ie = R(["\n            color: ", ";\n          "])), a.group.label))
  }, r), D("div", {
    role: "group",
    "aria-labelledby": l
  }, t));
}
function He(e) {
  throw Error("`OptionGroup` must be a child of a `Select` instance");
}
Ae.displayName = "OptionGroup", He.displayName = "OptionGroup", He.propTypes = {
  children: d.oneOfType([d.element, d.arrayOf(d.oneOfType([d.oneOf([!1, null, void 0, ""]), d.element]))]).isRequired,
  className: d.string,
  label: d.string.isRequired,
  disabled: d.bool
};
var Te = ["children"];
function Me(e) {
  return null == e || !1 === e || "" === e;
}
function Ge(e, n) {
  r.Children.forEach(e, function (e) {
    v(e, "Option") ? n(e) : v(e, "OptionGroup") ? Ge(e.props.children, function (r) {
      return n(r, e);
    }) : E(e) && Ge(e.props.children, n);
  });
}
function Re(e, n, t) {
  return r.Children.map(e, function (e) {
    if (v(e, "Option")) return D(Ce, n(e));
    if (v(e, "OptionGroup")) {
      var r = e.props,
        o = r.children,
        i = G(r, Te);
      return D(Ae, M({
        className: void 0
      }, i), Re(o, function (r) {
        return n(r, e);
      }, t));
    }
    return E(e) ? Re(e.props.children, n, t) : (Me(e) || null == t || t(e), null);
  });
}
function Le(e) {
  return null === e ? "" : void 0 !== e.props.value ? e.props.value : Array.isArray(e.props.children) ? e.props.children.filter(function (e) {
    return !Me(e);
  }).join("") : e.props.children.toString();
}
function Ve(e, n) {
  var r, t, o;
  return null !== (r = e.props.disabled) && void 0 !== r && r || null !== (t = null == n || null === (o = n.props) || void 0 === o ? void 0 : o.disabled) && void 0 !== t && t;
}
function Be(e, n, r) {
  return Le(e) === r && !Ve(e, n);
}
function Fe(e) {
  var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = n.initialValue,
    t = n.deps,
    o = void 0 === t ? [] : t,
    a = i(r);
  return s(function () {
    return {
      get current() {
        return a.current;
      },
      set current(n) {
        a.current = n, e(n);
      }
    };
  }, [e, a].concat(V(o)));
}
function Ke(e, n) {
  var r = a(function (e, n) {
    Array.isArray(e) ? e.forEach(r) : "function" == typeof e ? e(n) : e && (e.current = n);
  }, []);
  return Fe(a(function (n) {
    return r(e, n);
  }, [e, r]), {
    initialValue: n
  });
}
var Ze,
  qe,
  Ye = function (e) {
    var n = L(c(e), 2),
      r = n[0];
    return Fe(n[1], {
      initialValue: e,
      deps: [r]
    });
  },
  Ue = u(Ze || (Ze = R(["\n  position: relative;\n  text-align: left;\n  width: 100%;\n  border-radius: 3px;\n  line-height: 16px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n"]))),
  We = r.forwardRef(function (e, n) {
    var r = e.children,
      t = e.id,
      i = e.referenceElement,
      l = e.className,
      c = e.labelId,
      d = e.usePortal,
      f = void 0 === d || d,
      g = e.portalContainer,
      h = e.scrollContainer,
      m = e.portalClassName,
      v = e.popoverZIndex,
      y = o(ye),
      O = y.mode,
      j = y.size,
      S = y.disabled,
      E = y.open,
      I = de[O],
      P = pe[j],
      _ = Ke(n, null),
      z = b(),
      A = s(function () {
        if (z && _.current && i.current) {
          var e = i.current.getBoundingClientRect(),
            n = e.top,
            r = e.bottom,
            t = Math.max(z.height - r, n);
          return Math.min(274, t - 8);
        }
        return 274;
      }, [_, i, z]),
      T = a(function (e) {
        _.current && _.current.focus(), e.stopPropagation();
      }, [_]),
      G = H({
        popoverZIndex: v
      }, f ? {
        usePortal: f,
        portalClassName: m,
        portalContainer: g,
        scrollContainer: h
      } : {
        usePortal: f
      });
    return D(k, M({
      active: E && !S,
      spacing: 4,
      align: N.Bottom,
      justify: C.Middle,
      adjustOnMutation: !0,
      className: l,
      refEl: i
    }, G), D("ul", {
      "aria-labelledby": c,
      role: "listbox",
      ref: _,
      tabIndex: -1,
      onClick: T,
      className: p(Ue, u(qe || (qe = R(["\n              font-family: ", ";\n              font-size: ", "px;\n              min-height: ", "px;\n              max-height: ", "px;\n              background-color: ", ";\n              box-shadow: 0 3px 7px 0 ", ";\n\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n              }\n            "])), x.default, P.option.text, P.height, A, I.option.background.base, I.menu.shadow, w.Desktop, me.text)),
      id: t
    }, r));
  });
We.displayName = "ListMenu";
var Xe,
  $e,
  Je,
  Qe,
  en,
  nn,
  rn,
  tn,
  on,
  an,
  ln,
  sn,
  cn,
  dn,
  un = ["children", "value", "text", "name", "deselected", "readOnly", "onClose", "onOpen", "errorMessage", "state", "__INTERNAL__menuButtonSlot__"],
  pn = u(Xe || (Xe = R(["\n  margin-top: 2px;\n\n  // reset default Button padding\n  > span {\n    padding: 0;\n  }\n"]))),
  fn = u($e || ($e = R(["\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 100%;\n"]))),
  gn = r.forwardRef(function (e, r) {
    var t = e.children,
      i = e.value,
      l = e.text,
      s = e.name,
      c = e.deselected,
      d = (e.readOnly, e.onClose),
      f = e.onOpen,
      g = e.errorMessage,
      b = e.state,
      h = e.__INTERNAL__menuButtonSlot__,
      m = G(e, un),
      v = o(ye),
      y = v.mode,
      x = v.open,
      k = v.size,
      N = v.disabled,
      C = Ke(r, null),
      j = de[y],
      S = pe[k],
      E = y === ce ? n.red.base : "#F97216",
      A = a(function () {
        x ? d() : f(), C.current.focus();
      }, [d, f, x, C]);
    return D(h || I, M({}, m, {
      ref: C,
      name: s,
      value: i,
      disabled: N,
      onClick: A,
      variant: P.Default,
      darkMode: y === se,
      rightGlyph: D(_, null),
      "data-testid": "leafygreen-ui-select-menubutton",
      className: p(pn, u(Je || (Je = R(["\n          height: ", "px;\n          font-size: ", "px;\n          width: 100%;\n          color: ", ";\n          border-color: ", ";\n\n          @media only screen and (max-width: ", "px) {\n            height: ", "px;\n            font-size: ", "px;\n          }\n        "])), S.height, S.text, c ? j.text.deselected : j.text.base, x && !N ? j.border.open : j.border.base, w.Desktop, fe, ge), T({}, u(Qe || (Qe = R(["\n            border-color: ", ";\n            box-shadow: 0px 1px 2px rgba(87, 11, 8, 0.3);\n\n            &:hover,\n            &:active {\n              border-color: ", ";\n              box-shadow: ", ";\n            }\n          "])), E, E, y === ce ? "0px 4px 4px rgba(87, 11, 8, 0.3),\n              0px 0px 0px 3px ".concat(n.red.light3) : "0px 4px 4px rgba(87, 11, 8, 0.3), 0px 0px 0px 3px ".concat(n.red.dark2)), b === ve.Error && !!g))
    }), D("div", {
      className: u(en || (en = R(["\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          flex-grow: 1;\n          width: 90%;\n        "])))
    }, D("div", {
      className: fn
    }, l), b === ve.Error && g && D(z, {
      role: "presentation",
      className: u(nn || (nn = R(["\n              color: ", ";\n              margin-left: ", "px;\n            "])), E, O[1]),
      size: S.warningIcon
    })), t);
  });
gn.displayName = "MenuButton";
var bn = u(rn || (rn = R(["\n  font-family: ", ";\n  display: block;\n"])), x.default),
  hn = u(tn || (tn = R(["\n  margin-bottom: 2px;\n  font-weight: bold;\n"])));
function mn(e) {
  var r,
    t = e.children,
    o = e.darkMode,
    i = void 0 !== o && o,
    d = e.size,
    f = void 0 === d ? ue.Default : d,
    m = e.disabled,
    v = void 0 !== m && m,
    x = e.allowDeselect,
    k = void 0 === x || x,
    N = e.placeholder,
    C = void 0 === N ? "Select" : N,
    j = e.className,
    S = e.id,
    E = e.label,
    I = e["aria-labelledby"],
    P = e.description,
    _ = e.name,
    z = e.defaultValue,
    A = e.value,
    G = e.onChange,
    V = e.readOnly,
    B = e.usePortal,
    F = void 0 === B || B,
    K = e.portalContainer,
    Z = e.scrollContainer,
    q = e.portalClassName,
    Y = e.popoverZIndex,
    U = e.errorMessage,
    W = void 0 === U ? "error message right here" : U,
    X = e.state,
    $ = void 0 === X ? ve.None : X,
    J = e.__INTERNAL__menuButtonSlot__,
    Q = g({
      prefix: "select",
      id: S
    }),
    ee = s(function () {
      return null != I ? I : "".concat(Q, "-label");
    }, [I, Q]);
  E || I || console.error("For screen-reader accessibility, label or aria-labelledby must be provided to Select.");
  var ne = "".concat(Q, "-description"),
    re = "".concat(Q, "-menu"),
    te = L(c(!1), 2),
    oe = te[0],
    ie = te[1],
    ae = Ye(null),
    le = Ye(null),
    fe = i ? se : ce,
    ge = de[fe],
    me = pe[f],
    xe = s(function () {
      return {
        mode: fe,
        size: f,
        open: oe,
        disabled: v
      };
    }, [fe, f, oe, v]);
  l(function () {
    void 0 !== A && void 0 === G && !0 !== V && console.warn("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
  }, [G, V, A]);
  var we = a(function () {
      ie(!0);
    }, []),
    Oe = a(function () {
      ie(!1), ae.current.focus();
    }, [ae]);
  l(function () {
    if (oe) {
      var e = function (e) {
        var n = ae.current.contains(e.target) || le.current.contains(e.target);
        ie(n);
      };
      return document.addEventListener("mousedown", e), function () {
        document.removeEventListener("mousedown", e);
      };
    }
  }, [le, ae, oe]);
  var ke = s(function () {
      var e = null;
      return void 0 === A && void 0 !== z && Ge(t, function (n, r) {
        Be(n, r, z) && (e = n);
      }), e;
    }, [t, z, A]),
    Ne = L(c(ke), 2),
    je = Ne[0],
    Se = Ne[1];
  l(function () {
    var e;
    null !== je && Se(null !== (e = function (e, n) {
      var r, t, o, i, a, l, s, c;
      return Ge(e, function (e) {
        if (e === n) a = n;else if (e.props.children === n.props.children && e.props.value === n.props.value) {
          var r;
          null !== (r = l) && void 0 !== r || (l = e);
        } else if (void 0 !== e.props.value && e.props.value === n.props.value) {
          var t;
          null !== (t = s) && void 0 !== t || (s = e);
        } else if (Le(e) === Le(n)) {
          var o;
          null !== (o = c) && void 0 !== o || (c = e);
        }
      }), null !== (r = null !== (t = null !== (o = null !== (i = a) && void 0 !== i ? i : l) && void 0 !== o ? o : s) && void 0 !== t ? t : c) && void 0 !== r ? r : null;
    }(t, je)) && void 0 !== e ? e : ke);
  }, [t, ke, je]);
  var De = s(function () {
      if (void 0 !== A) {
        var e = null;
        return Ge(t, function (n, r) {
          Be(n, r, A) && (e = n);
        }), e;
      }
      return je;
    }, [t, je, A]),
    Ee = a(function (e, n) {
      void 0 === A && Se(e), null == G || G(Le(e), n), ze(void 0), Oe();
    }, [G, Oe, A]),
    Ie = a(function (e, n) {
      return function (r) {
        r.preventDefault(), r.stopPropagation(), v || n || (Ee(e, r), Oe());
      };
    }, [v, Oe, Ee]),
    Pe = L(c(), 2),
    _e = Pe[0],
    ze = Pe[1],
    Ae = s(function () {
      var e = [];
      return k && e.push(null), Ge(t, function (n, r) {
        Ve(n, r) || e.push(n);
      }), e;
    }, [t, k]),
    He = a(function (e) {
      void 0 !== _e && Ee(_e, e);
    }, [_e, Ee]),
    Te = a(function () {
      ze(Ae[0]);
    }, [Ae]),
    Me = a(function () {
      ze(Ae[Ae.length - 1]);
    }, [Ae]),
    Fe = a(function () {
      if (void 0 === _e || 0 === Ae.indexOf(_e)) Me();else {
        var e = Ae.indexOf(_e) - 1;
        ze(Ae[e]);
      }
    }, [Ae, _e, Me]),
    Ke = a(function () {
      if (void 0 === _e || Ae.indexOf(_e) === Ae.length - 1) Te();else {
        var e = Ae.indexOf(_e) + 1;
        ze(Ae[e]);
      }
    }, [Ae, _e, Te]),
    Ze = a(function (e, n) {
      return function (r) {
        r.preventDefault(), r.stopPropagation(), v || n || ze(e);
      };
    }, [v]),
    qe = a(function (e) {
      var n, r;
      if (!(e.ctrlKey || e.shiftKey || e.altKey)) {
        var t = null === (n = le.current) || void 0 === n ? void 0 : n.contains(document.activeElement),
          o = null === (r = ae.current) || void 0 === r ? void 0 : r.contains(document.activeElement);
        if (o || t) switch (e.keyCode) {
          case y.Tab:
          case y.Escape:
            Oe(), ze(void 0);
            break;
          case y.Enter:
          case y.Space:
            oe && !o && e.preventDefault(), He(e);
            break;
          case y.ArrowUp:
            !oe && o && we(), e.preventDefault(), Fe();
            break;
          case y.ArrowDown:
            !oe && o && we(), e.preventDefault(), Ke();
        }
      }
    }, [le, ae, Oe, oe, He, Fe, Ke, we]);
  h("keydown", qe);
  var Ue = b(),
    Xe = s(function () {
      var e = !1;
      return Ge(t, function (n) {
        e || (e = void 0 !== n.props.glyph);
      }), e;
    }, [t]),
    $e = s(function () {
      return null !== Ue && null !== le.current && void 0 === _e && oe;
    }, [_e, le, oe, Ue]),
    Je = s(function () {
      var e = null === De;
      return D(Ce, {
        className: void 0,
        glyph: void 0,
        selected: e,
        focused: null === _e,
        disabled: !1,
        onClick: Ie(null, !1),
        onFocus: Ze(null, !1),
        isDeselection: !0,
        hasGlyphs: !0,
        triggerScrollIntoView: e && $e
      }, C);
    }, [$e, _e, Ie, Ze, C, De]),
    Qe = s(function () {
      return Re(t, function (e, n) {
        var r = e === De,
          t = Ve(e, n);
        return {
          className: e.props.className,
          glyph: e.props.glyph,
          selected: r,
          focused: e === _e,
          disabled: t,
          children: e.props.children,
          isDeselection: !1,
          hasGlyphs: Xe,
          onClick: Ie(e, t),
          onFocus: Ze(e, t),
          triggerScrollIntoView: r && $e
        };
      }, function () {
        console.error("`Select` instance received child that is not `Option` or `OptionGroup`.");
      });
    }, [$e, t, _e, Ie, Ze, Xe, De]),
    en = H({
      popoverZIndex: Y
    }, F ? {
      usePortal: F,
      portalClassName: q,
      portalContainer: K,
      scrollContainer: Z
    } : {
      usePortal: F
    });
  return D("div", {
    className: p(T({}, u(on || (on = R(["\n            cursor: not-allowed;\n          "]))), v), j)
  }, E && D("label", {
    id: ee,
    className: p(bn, hn, u(an || (an = R(["\n              color: ", ";\n              font-size: ", "px;\n              line-height: ", "px;\n\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n                line-height: ", "px;\n              }\n            "])), v ? ge.label.disabled : ge.label.base, me.label.text, me.label.lineHeight, w.Desktop, be.text, be.lineHeight), T({}, u(ln || (ln = R(["\n                cursor: not-allowed;\n              "]))), v))
  }, E), P && D("div", {
    id: ne,
    className: p(bn, u(sn || (sn = R(["\n              color: ", ";\n              font-size: ", "px;\n              line-height: ", "px;\n\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n                line-height: ", "px;\n              }\n            "])), ge.description, me.description.text, me.description.lineHeight, w.Desktop, he.text, he.lineHeight))
  }, P), D(ye.Provider, {
    value: xe
  }, D(gn, {
    ref: ae,
    name: _,
    readOnly: V,
    value: Le(De),
    text: null !== De ? De.props.children : C,
    deselected: null === De,
    onOpen: we,
    onClose: Oe,
    "aria-labelledby": ee,
    "aria-controls": re,
    "aria-expanded": oe,
    "aria-describedby": ne,
    "aria-invalid": $ === ve.Error,
    errorMessage: W,
    state: $,
    __INTERNAL__menuButtonSlot__: J
  }, D(We, M({
    labelId: ee,
    id: re,
    referenceElement: ae,
    ref: le,
    className: u(cn || (cn = R(["\n              width: ", "px;\n            "])), null === (r = ae.current) || void 0 === r ? void 0 : r.clientWidth)
  }, en), k && Je, Qe))), $ === ve.Error && W && D("span", {
    className: p(bn, u(dn || (dn = R(["\n              color: ", ";\n              font-size: ", "px;\n              line-height: ", "px;\n              margin-top: ", "px;\n              padding-left: 2px;\n\n              @media only screen and (max-width: ", "px) {\n                font-size: ", "px;\n                line-height: ", "px;\n              }\n            "])), i ? "#F97216" : n.red.base, me.description.text, me.description.lineHeight, O[1], w.Desktop, he.text, he.lineHeight))
  }, W));
}
mn.displayName = "Select", mn.propTypes = {
  label: d.string,
  "aria-labelledby": d.string,
  description: d.string,
  placeholder: d.string,
  className: d.string,
  darkMode: d.bool,
  size: d.oneOf(Object.values(ue)),
  disabled: d.bool,
  id: d.string,
  value: d.string,
  defaultValue: d.string,
  onChange: d.func,
  readOnly: d.bool,
  errorMessage: d.string,
  state: d.oneOf(Object.values(ve))
};
export { je as Option, He as OptionGroup, mn as Select, ue as Size, ve as State };